export interface YardSelectorProps {
  hasError?: boolean
  journeyId?: number | null
  stackDirection?: 'row' | 'column'
  prefillPosition?: OccupancyType
  onPositionChange?: (value: boolean) => void
}

export enum OccupancyType {
  Occupied = 'Occupied',
  Reserved = 'Reserved',
}

export interface CurrentPositionByJourneyIdResponse {
  journeyId?: number
  blockId?: string | null
  positions: PositionDto[]
}

export interface PositionDto {
  bay: number
  row: number
  tier: number
}
